import { join } from 'node:path';
import { globby } from 'globby';
import { useAsyncCallback } from '@wix/cli-ui-kit';
import { CliErrorCode, CliError } from '@wix/cli-error';
import { readBuildManifest } from '../../../files/build.config.js';
import { useProjectModel } from '../../../model.js';

export function useLoadBuildFiles() {
  const {
    model: { projectFolder },
  } = useProjectModel();

  return useAsyncCallback(async () => {
    const buildManifest = await readBuildManifest(projectFolder);

    const client = (await loadFiles(buildManifest.clientDir)).filter(
      ({ path }) => {
        if (path === buildManifest.appManifestPath) {
          return false;
        }
        // cloudflare adapter for astro project is storing server files inside client directory
        // so we must ensure that server files are not uploaded as static files.
        if (
          buildManifest.serverDir &&
          path.startsWith(buildManifest.serverDir)
        ) {
          return false;
        }
        return true;
      }
    );

    const server = (
      buildManifest.serverDir ? await loadFiles(buildManifest.serverDir) : []
    ).filter(({ path }) => {
      if (path === buildManifest.appManifestPath) {
        return false;
      }
      return true;
    });

    if (client.length + server.length === 0) {
      throw new CliError({
        code: CliErrorCode.BuildOutputMissing({
          reason: "Could't find neither client nor server build output files.",
        }),
        cause: null,
      });
    }

    return { client, server };
  });
}

async function loadFiles(cwd: string) {
  return globby('**/*', { cwd, onlyFiles: true }).then((files) =>
    files.map((relativePath) => {
      return {
        path: join(cwd, relativePath),
        relativePath,
      };
    })
  );
}
